module.exports = __webpack_public_path__ + "static/media/HCMM336.28f3adf0.jpg";